import { useState } from "react";
import { useMutation } from "@apollo/client";
import { EditGroupLabelsInput, EditGroupLabelsPayload } from "@models/ISchema";
import { groupLabelsMutation } from "../graphql/groupLabes.mutation";
import { ILabel } from "../EditLabels/ContextEditLabels";

type Response = [
  EditGroupLabelsPayload,
  (
    labels: ILabel[],
    onSuccess?: (response: EditGroupLabelsPayload) => void,
    onError?: (error: Error) => void,
  ) => void,
];

const useUpdateGroupLabel = (id: string, scenario: string, origin: string): Response => {
  const [response, setResponse] = useState<EditGroupLabelsPayload>(null);

  const [labelsMutation] = useMutation(groupLabelsMutation, {});

  const updateGroupLabels = async (
    labels: ILabel[],
    onSuccess?: (response: EditGroupLabelsPayload) => void,
    onError?: (error: Error) => void,
  ) => {
    try {
      const input: EditGroupLabelsInput = {
        dryRun: false,
        groupId: id,
        labelIds: (labels ?? []).map(label => label?.id),
      };
      const variables = {
        scenarioId: scenario,
        originId: origin,
        input,
      };
      const { data } = await labelsMutation({ variables });
      const newResponse: EditGroupLabelsPayload = data?.cube?.editGroupLabels;
      setResponse(newResponse);
      onSuccess?.(newResponse);
    } catch (e) {
      setResponse(null);
      console.error("[labels]", e);
      onError?.(e as Error);
    }
  };

  return [response, updateGroupLabels];
};

export default useUpdateGroupLabel;
